import { RootState } from '@src/redux/store'
import { prop, propOr } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  STAFF,
  STAFF_ALL,
  STAFF_ALL_FILTERED,
  STAFF_DEPARTMENT_POSITION,
  STAFF_FULL_INFO_UPDATE,
  STAFF_LIST,
  STAFF_PERSONAL_INFO,
  STAFF_USERNAME,
} from '../constants/actionTypes'

const staffSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const staffSelector = createSelector(staffSelectors, data => data[STAFF])

export const staffListSelector = createSelector(staffSelectors, data => data[STAFF_LIST])

export const staffDepartmentPositionSelector = createSelector(staffSelectors, data => data[STAFF_DEPARTMENT_POSITION])

export const staffAllSelector = createSelector(staffSelectors, data => data[STAFF_ALL])

export const staffAllFilteredSelector = createSelector(staffSelectors, data => data[STAFF_ALL_FILTERED])

export const staffPersonalInfoUpdateSelector = createSelector(staffSelectors, data => data[STAFF_PERSONAL_INFO])

export const staffFullInfoUpdateSelector = createSelector(staffSelectors, data => data[STAFF_FULL_INFO_UPDATE])

export const staffAllOptionsSelector = createSelector(staffAllSelector, selected => {
  return {
    loading: selected.loading,
    error: selected.error,
    options: Array.isArray(selected.data)
      ? selected.data.map(item => ({
          label: `${propOr('', 'firstname', item)} ${propOr('', 'lastname', item)} (${propOr('', 'username', item)})`,
          value: item.id,
        }))
      : [],
  }
})

export const staffAllOptionsWithUserIdSelector = createSelector(staffAllSelector, selected => {
  return {
    loading: selected.loading,
    error: selected.error,
    options: Array.isArray(selected.data)
      ? selected.data.map(item => ({
          label: `${propOr('', 'firstname', item)} ${propOr('', 'lastname', item)} (${propOr('', 'username', item)})`,
          value: item.user_id,
        }))
      : [],
  }
})

export const staffAllFilteredOptionsSelector = createSelector(staffAllFilteredSelector, selected => {
  return {
    loading: selected.loading,
    error: selected.error,
    options: Array.isArray(selected.data)
      ? selected.data.map(item => ({
          label: `${propOr('', 'firstname', item)} ${propOr('', 'lastname', item)} (${propOr('', 'username', item)})`,
          value: item.id,
        }))
      : [],
  }
})

export const staffUsernameSelector = createSelector(staffSelectors, data => data[STAFF_USERNAME])
